import React from 'react';
import {
  Card,
  CardContent,
  Grid,
  IconButton,
  Paper,
  Typography,
} from '@mui/material';
import { MoreVert as MoreVertIcon } from '@mui/icons-material';

interface MobileCardGridProps<T> {
  data: T[];
  renderCard: (item: T) => React.ReactNode;
  onMenuClick?: (e: React.MouseEvent<HTMLElement>, item: T) => void;
  getItemKey: (item: T) => string | number;
  emptyIcon?: React.ReactNode;
  emptyMessage?: string;
}

/**
 * Generic mobile card grid with three-dot menu on each card and empty state.
 * Page only provides the card body content via renderCard.
 */
function MobileCardGridComponent<T>({
  data,
  renderCard,
  onMenuClick,
  getItemKey,
  emptyIcon,
  emptyMessage = 'No items found',
}: MobileCardGridProps<T>) {
  return (
    <Grid container spacing={2}>
      {data.map((item) => (
        <Grid item xs={12} key={getItemKey(item)}>
          <Card sx={{ position: 'relative' }}>
            <CardContent sx={{ pb: 1 }}>
              {onMenuClick && (
                <IconButton
                  onClick={(e) => onMenuClick(e, item)}
                  size="small"
                  sx={{
                    position: 'absolute',
                    top: 8,
                    right: 8,
                  }}
                >
                  <MoreVertIcon />
                </IconButton>
              )}
              {renderCard(item)}
            </CardContent>
          </Card>
        </Grid>
      ))}
      {data.length === 0 && (
        <Grid item xs={12}>
          <Paper sx={{ p: 4, textAlign: 'center' }}>
            {emptyIcon}
            <Typography color="text.secondary">
              {emptyMessage}
            </Typography>
          </Paper>
        </Grid>
      )}
    </Grid>
  );
}

export default MobileCardGridComponent;
